import { mailvibesApi } from ".";

export const axiosRemovetoken = () => {
  localStorage.removeItem("auth");
  delete mailvibesApi.defaults.headers.common["x-access-token"];
};
